import { actionCreator, ActionTypeCreator } from 'app-webtech-core/actions';
import {
  getCCMenu,
  getCCIndexFromCharacter,
} from 'app-webtech-core/modules/player/actions/helpers/ccMenuIndexHelper';

const actions = { actionCreator, ActionTypeCreator };

export const helpers = {
  actions,
  getCCMenu,
  getCCIndexFromCharacter,
};
